import { DateTime } from 'luxon';

const entityMap = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	'\'': '&#39;',
	'/': '&#x2F;',
	'`': '&#x60;',
	'=': '&#x3D;',
};

export function escapeHtml(string) {
	return String(string).replace(/[&<>"'`=\/]/g, (s) => entityMap[s]);
}

export function removeXssTriggers(string) {
	let result = '';
	// if there's no html in string, return string
	if (RegExp.prototype.test.bind(/(<([^>]+)>)/i)) {
		try {
			// check if valid html, else return empty string
			const html = $($.parseHTML(string));
			const htmlNodes = html.get();
			for (let i = 0; i < htmlNodes.length; i++) {
				if (htmlNodes[i].nodeName !== '#text') {
					if (htmlNodes[i].hasAttribute('onerror')) {
						htmlNodes[i].removeAttribute('onerror');
					}
					if (htmlNodes[i].hasAttribute('onload')) {
						htmlNodes[i].removeAttribute('onload');
					}
					result += htmlNodes[i].outerHTML;
				} else {
					result += htmlNodes[i].data;
				}
			}

			return result;
		} catch (error) {
			return '';
		}
	}
	return string;
}

const allowedDomains = ['www.youtube.com', 'player.vimeo.com'];
export function removeIframesExcept(htmlString, domains = []) {
	const parser = new DOMParser(); // Create a DOMParser object
	const doc = parser.parseFromString(htmlString, 'text/html'); // Parse the HTML string into a DOM document

	const iframes = doc.querySelectorAll('iframe'); // Select all iframe elements in the document

	for (const iframe of iframes) {
	  const src = iframe.getAttribute('src'); // Get the src attribute of the iframe

	  // Check if the iframe's src matches any of the allowed domains
	  let shouldRemove = true;
	  if (src) {
		const url = new URL(src);
		const srcDomain = url.hostname;
		for (const domain of allowedDomains.concat(domains)) {
		  if (srcDomain.includes(domain)) {
			shouldRemove = false;
			break;
		  }
		}
	  }

	  if (shouldRemove) {
		iframe.parentNode.removeChild(iframe); // Remove the iframe if its src is not allowed
	  }
	}

	return doc.body.innerHTML; // Return the modified HTML string from the document body
}

export const randomString = function (length) {
	const chars = '0123456789' + 'ABCDEFGHIJKLMNOPQRSTUVWXTZ' + 'abcdefghiklmnopqrstuvwxyz';

	let random = '';
	for (let i = 0; i < length; i++) {
		const rnum = Math.floor(Math.random() * chars.length);
		random += chars.substring(rnum, rnum + 1);
	}

	return random;
};

export const destroyBackboneView = (view) => {
	if (view) {
		view.undelegateEvents();
		$(view.el)
			.removeData()
			.unbind();
	}
};

export const makeStringFileSafe = (str) => str.replace(/[^a-z0-9]/gi, '_').toLowerCase();

export function decimalPlaces(num) {
	const match = (`${num}`).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
	if (!match) {
		return 0;
	}
	return Math.max(
		0,
		// Number of digits right of decimal point.
		(match[1] ? match[1].length : 0)
        // Adjust for scientific notation.
        - (match[2] ? +match[2] : 0),
	);
}

export function round(value, decimals) {
	return Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`);
}

export function prettyDateTime(datetime) {
	if (datetime == null) {
		return '';
	}
	let dt = DateTime.fromISO(datetime, { zone: 'utc' });
	dt = dt.setZone(window.LOCALE.timezone);
	return dt.toFormat('LLL d yyyy hh:mm a (ZZZZ)');
}

export function hasPermission(permissions, permission) {
	if (permissions.includes('full')) {
		return true;
	}
	return permissions.includes(permission);
}

export function hasAnyPermission(permissions, permissionList) {
	if (permissions.includes('full')) {
		return true;
	}
	return permissionList.some((permission) => permissions.includes(permission));
}

export const getCookie = (name) => {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		return parts.pop().split(';').shift();
	}
	return '';
};

export const isSafeRedirectUrl = (url) => {
	return !(typeof url !== 'string' || !url.trim().startsWith('/') || url.trim().startsWith('//') || url.trim().includes(':'));
};